import { useContext } from "react";
import { appContext } from "../../context/AppContext";
import { AccountPageSection } from "../../layouts/AccountPageSection";
import { Grid } from "@mui/material";
import Parcel from "single-spa-react/parcel";

export function AccountSecurity(props) {
  const context = useContext(appContext);
  return (
    <AccountPageSection
      testId={"account-laptop-security-status"}
      label={"Hardware Security"}
    >
      <Grid item xs={12}>
        <Parcel
          config={() => System.import("@mytw/account-laptop-security-status")}
          {...props}
          accountId={context.appConfig.accountId}
        />
      </Grid>
    </AccountPageSection>
  );
}
